import { find, findAll } from "utils/dom"
import { formatMilliseconds, formatVotingDate } from "../utils/formats"
import "toastify-js/src/toastify.css"
import Toastify from 'toastify-js'
import Swiper from "swiper"
import { Navigation } from "swiper/modules"
// CSS do Swiper NÃO importar aqui — vazaria p/ Superjúri via main.js.
// Layout do carrossel fica em styles.css (#indicacao-publica .peb26-vote-cats).


export default function () {
	const Indicacao = find("[js-page='indicacao']")
	if (!Indicacao) return

	console.log('indicaçao fase 1 22/07')
	let currentIndicationStep = 1
	let indicatedQuantity = 0
	let votingDateInterval

	function alertRequiredFields(fields, txt, verify = true) {
	fields.map(input => {
		let targetElement = input;

		// Caso seja um SELECT oculto com nice-select
		if (input.tagName === 'SELECT' && input.closest('.custom-select2')) {
			const customSelect = input.closest('.custom-select2');
			const niceSelect = customSelect.querySelector('.nice-select');

			// Remove mensagem anterior, se houver
			const existingMessage = customSelect.querySelector('p.text-paragraph-4');
			if (existingMessage) existingMessage.remove();

			// Insere após o nice-select visível
			niceSelect.insertAdjacentHTML('afterend', `
				<p class="text-paragraph-4" style="color: rgb(220, 38, 38)">
					${txt}
				</p>
			`);
			return;
		}

		// Para campos normais (input, checkbox, etc.)
		const inputParent = input?.parentNode;
		const existingMessage = inputParent?.parentNode?.querySelector('p.text-paragraph-4');
		if (existingMessage) existingMessage.remove();

		if ((verify && !input.checked) && input.type === "checkbox") {
			inputParent.insertAdjacentHTML('afterend', `
				<p class="text-paragraph-4" style="color: rgb(220, 38, 38)">
					${txt}
				</p>
			`);
		} else if ((verify && !input.value) || !verify) {
			inputParent.insertAdjacentHTML('afterend', `
				<p class="text-paragraph-4" style="color: rgb(220, 38, 38)">
					${txt}
				</p>
			`);
		}
	});
}









	function handleChangeSelect(ev) {
		const select = ev.target
		const selectValue = select.value
		const inputField = select.closest('[js-field]').querySelector('.Input')

		if (selectValue === 'others') {
			inputField.querySelector('input').value = ''
			inputField.classList.remove('hidden')
		} else {
			inputField.classList.add('hidden')
			inputField.querySelector('input').value = selectValue
		}
	}

	function verifyFieldsOnSubmit() {
  
		const formElement = find('form')
		const inputFields = findAll('[data-field-required="true"]')
		const inputValues = inputFields.map(v => v.value)
		let hasEmptyInput = true;


		inputFields.some((input) => {
			if (input.type === 'checkbox' || input.type === 'radio') {
				return !input.checked;
			}
			return !input.value;
		});



		inputFields
			.filter(input => input.name.startsWith("valor-indicado"))
			.map(input => {
				const count = inputValues.filter(i => i === input.value && input.value || '').length

				if (count > 1) {
					alertRequiredFields([input], 'Indicado repetido', false)
				}
			})

		inputFields.filter((input) => {
			if (input.type == 'checkbox') {
				return input;
			}
		}).map((input) => {
			const is_checked = (input.checked ? true : false)
			if (is_checked === false) {
				alertRequiredFields([input], 'Campo obrigatório')
				console.log(input)
			}
		})

		if (hasEmptyInput && Indicacao.id === 'indicacao' ) {
			alertRequiredFields(inputFields, 'Campo obrigatório')

		}
		else if (Indicacao.id === 'indicacao-superjuri-BK') {

				const selectFields = findAll('[js-select]')
				const inputJogo = findAll('.custom-input input')


			const repeatedFields = inputFields
				.filter(input => input.name.startsWith("valor-indicado"))
				.map(input => {
					const count = inputValues.filter(i => i === input.value && input.value || '').length

					if (count > 1)
						alertRequiredFields([input], 'Indicado repetido', false)

					return count
				})

			!repeatedFields.some(i => i > 1) && formElement.submit()
		} 

else if (Indicacao.id === 'indicacao-superjuri') {
    const formElement = find('form');

    // Apenas indicados (select ou input com name começando com valor-indicado)
    const indicadoFields = findAll('[js-select], input[name^="valor-indicado"]');
    let hasAtLeastOneIndicado = false;
    let hasRepeatedIndicado = false;
    let missingJogoFields = false;
    let missingCustomInput = false;

    const selectedValues = [];

    indicadoFields.forEach((field) => {

			 // Pula input que já foi lido via select "others"
    if (field.matches('input[name^="valor-indicado"]') && field.closest('[js-field]')?.querySelector('select[js-select]')?.value === 'others') {
        console.log('Pulando input já lido via select "others":', field);
        return;
    }

        let value = field.value.trim();
				// console.log(field,value)
        // Caso seja select e tenha "others"
        if (field.matches('[js-select]') && value === 'others') {
            const fieldBlock = field.closest('[js-field]');
            if (fieldBlock) {
                const customInput = fieldBlock.querySelector('input[name^="valor-indicado"]');
                if (customInput) {
                    value = customInput.value.trim();
                    if (!value) {
                        alertRequiredFields([customInput], 'Preencha o campo customizado');
                        missingCustomInput = true;
                    }
                } else {
                    alertRequiredFields([field], 'Preencha o campo customizado');
                    missingCustomInput = true;
                }
            }
        }

				
        if (value) {
					 
            hasAtLeastOneIndicado = true;
		
            // Checa repetição apenas se o campo estiver visível e preenchido
            if (field.offsetParent !== null) {
                const normalizedValue = value.toLowerCase().trim();;
								 console.log('SelectedValues antes de verificar repetido:', selectedValues);

								// Verifica se o valor já foi selecionado (ignorando maiúsculas/minúsc
                if (selectedValues.map(v => v.toLowerCase().trim()).includes(normalizedValue)) {
							       console.log('Repetido detectado:', normalizedValue);

											Toastify({
															text: 'Não é permitido selecionar o mesmo indicado mais de uma vez.',
															style:{
																background : "linear-gradient(to right, #efbb6e, #efbb6e)",
																color: '#000',
																fontFamily: 'Bw Stretch, sans serif',
																boxShadow: 'none',
																fontSize: '1.5rem'
															},
													}).showToast();
                    alertRequiredFields([field], 'Indicado já selecionado');

                    hasRepeatedIndicado = true;
                } else {
                    selectedValues.push(value);
										console.log('SelectedValues atualizado:', selectedValues);

                }
            }

						console.log('value', selectedValues)
            // Verifica se o "jogo" correspondente existe e está preenchido
            const fieldBlock = field.closest('[js-field]');
            if (fieldBlock) {
                const jogoInput = fieldBlock.nextElementSibling?.querySelector('input[name^="valor-jogo"]');
                if (jogoInput && jogoInput.offsetParent !== null) { // só valida se estiver visível
                    if (!jogoInput.value.trim()) {

												Toastify({
															text: 'Preencha o campo "Jogo do indicado" ',
															style:{
																background : "linear-gradient(to right, #efbb6e, #efbb6e)",
																color: '#000',
																fontFamily: 'Bw Stretch, sans serif',
																boxShadow: 'none',
																fontSize: '1.5rem'
															},
													}).showToast();

                        alertRequiredFields([jogoInput], 'Preencha o campo "Jogo do indicado"');
                        missingJogoFields = true;
                    }
                }
            }
        }
    });

    // Validação final
    if (!hasAtLeastOneIndicado) {
        alertRequiredFields(indicadoFields, 'Preencha pelo menos um indicado');

						Toastify({
															text: 'Preencha pelo menos um indicado',
															style:{
																background : "linear-gradient(to right, #efbb6e, #efbb6e)",
																color: '#000',
																fontFamily: 'Bw Stretch, sans serif',
																boxShadow: 'none',
																fontSize: '1.5rem'
															},
													}).showToast();

    }

		


			console.log({
					hasRepeatedIndicado,
					missingJogoFields,
					missingCustomInput,
					hasAtLeastOneIndicado,
					formElement
			});

			console.log('deploy novo')
				const formData = new FormData(formElement);

			for (const [name, value] of formData.entries()) {
				console.log(name, value);
			}

    if (!hasRepeatedIndicado && !missingJogoFields && !missingCustomInput && hasAtLeastOneIndicado) {
		
			console.log('Formulário pronto para envio:', formElement);
			

        formElement.submit();
    }
}

		
		
		
		else if (Indicacao.id == 'indicacao-publica') {
			
			const repeatedFields = inputFields
				.filter(input => input.name.startsWith("valor-indicado"))
				.map(input => {
					const count = inputValues.filter(i => i === input.value && input.value || '').length

					if (count > 1)
						alertRequiredFields([input], 'Indicado repetido', false)

					return count
				})

			if (!repeatedFields.some(i => i > 1)) {
				const personalForm = document.getElementById('indicacao-publica-form')
				if (personalForm) savePersonalDataToStorage(personalForm)
				formElement.submit()
			}
		}
	}

	function verifyGameFields() {
		const gameInputs = findAll('[name^="valor-jogo"]')

		return gameInputs.map(input => {
			const categoryContent = input.closest('[data-category-content]')
			const indicated = categoryContent.querySelector('[name^="valor-indicado"]').value
			const inputParent = categoryContent.querySelector('[js-select]')

			if (inputParent != 'others') {
				return false
			}
			if (indicated && !input.value) {
				alertRequiredFields([input], 'Campo obrigatório')
				return true

			} else return false
		})
	}

	function updateIndicationSteps() {

		const indicationStepMarks = findAll("[data-step-mark]")
		const indicationSteps = findAll("[data-step-content]")
		const voteCats = document.querySelector('.peb26-vote-cats')

		indicationSteps?.map(step => step.classList.add('hidden'))
		indicationSteps.find((step => +step.dataset.stepContent === currentIndicationStep))
			?.classList.remove('hidden')

		// Carrossel de categorias só faz sentido no step 1 (indicação)
		if (voteCats) {
			voteCats.classList.toggle('hidden', currentIndicationStep !== 1)
		}

		indicationStepMarks?.map(el => {
			const step = +el.dataset.stepMark

			if (step <= currentIndicationStep) {
				el.style.background = 'rgb(239, 187, 110)'
				el.style.color = '#000'
				el.classList.add('is-active')
			} else {
				el.style.background = ''
				el.style.color = ''
				el.classList.remove('is-active')
			}
		})
	}

	function handleChangeIndicationSteps() {
		const nextStepAction = find('[data-next-step]')

  
		nextStepAction.addEventListener('click', () => {
      // debugger
			

			const hasMandatoryField = verifyGameFields().some(v => v)
			const emptyField = findAll('[name^="valor-indicado"]').filter(f => !f.value)
			const stickSimple = find('[data-stick-simple]')
			const stickComplete = find('[data-stick-complete]')

			if (indicatedQuantity === 0) {
				//		const emptyField = findAll('[name^="valor-indicado"]').filter(f => !f.value)
				alertRequiredFields(emptyField, 'Campo obrigatório')

				return
			}

			// if (!hasMandatoryField && (emptyField.length === 0)) {
			if (!hasMandatoryField && emptyField.length < findAll('[name^="valor-indicado"]').length) {

				currentIndicationStep++
				updateIndicationSteps()

				if(stickSimple){
					stickSimple.classList.add('hidden')
				}
				if(stickComplete){
					stickComplete.classList.remove('hidden')
				}

				find('#anchor').scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				})
			}
		})
	}

	function handleFilterCategoryRUIMOLD() {
		numbersHeader()
		numbersIndicated()

		const categoryButtons = findAll('[data-category-button]')
		const categoriesContent = findAll('[data-category-content]')
		const buttons = categoryButtons.map(header => header.querySelector('.frame button'))
 
		// buttons.forEach(button => {
		// 	button.querySelector('span').innerText.toLowerCase() === 'popular'
		// 		? button.classList.add('ativo')
		// 		: ''

		// 	button.addEventListener('click', () => {
		// 		buttons.map(btn => btn.classList.remove('ativo'))
		// 		button.classList.add('ativo')
		// 	})
		// })

		// categoryButtons.forEach(btn => {
		// 	btn.addEventListener('click', () => {
		// 		btn.classList.add('ativo')

		// 		categoriesContent.forEach(cat => {
		// 			if (btn.dataset.categoryButton === cat.dataset.categoryContent) {
		// 				cat.classList.add('block')
		// 				cat.classList.remove('hidden')
		// 			}
		// 			else if (btn.dataset.categoryButton === '2') {
		// 				cat.classList.remove('hidden')
		// 			}
		// 			else {
		// 				cat.classList.add('hidden')
		// 			}
		// 		})

		// 		numbersHeader()
		// 		numbersIndicated()
		// 	})
		// })
	}

function handleFilterCategory() {
	numbersHeader()
	numbersIndicated()

	const categoryButtons = findAll('[data-category-button]')
	const categoriesContent = findAll('[data-category-content]')
	const activeFilters = new Set()

	categoryButtons.forEach(btn => {
		const category = btn.dataset.categoryButton.toLowerCase().trim()
		const button = btn.querySelector('button')

		button.addEventListener('click', e => {
			e.preventDefault()

			const isTodas = category === 'todas'

			if (isTodas) {
				// Resetar tudo se clicar em "Todas"
				activeFilters.clear()
				categoryButtons.forEach(b => b.classList.remove('ativo'))
				btn.classList.add('ativo')

				categoriesContent.forEach(cat => {
					cat.classList.remove('hidden')
					cat.classList.add('block')
				})
			} else {
				// Desmarcar "Todas"
				const todasBtn = categoryButtons.find(b => b.dataset.categoryButton.toLowerCase().trim() === 'todas')
				todasBtn?.classList.remove('ativo')

				// Alternar estado do botão clicado
				if (btn.classList.contains('ativo')) {
					btn.classList.remove('ativo')
					activeFilters.delete(category)
				} else {
					btn.classList.add('ativo')
					activeFilters.add(category)
				}

				// Nenhum filtro? Volta para "Todas"
				if (activeFilters.size === 0) {
					todasBtn?.classList.add('ativo')
					categoriesContent.forEach(cat => {
						cat.classList.remove('hidden')
						cat.classList.add('block')
					})
				} else {
					// Mostrar somente categorias ativas
					categoriesContent.forEach(cat => {
						const catCategory = cat.dataset.categoryContent.toLowerCase().trim()
						if (activeFilters.has(catCategory)) {
							cat.classList.remove('hidden')
							cat.classList.add('block')
						} else {
							cat.classList.add('hidden')
							cat.classList.remove('block')
						}
					})
				}
			}

			numbersHeader()
			numbersIndicated()
		})
	})
}

	function initCategoriaCarousel() {
		const carousel = document.querySelector('.swiperCategoriaVotacao')
		if (!carousel) return

		// Desktop: grid CSS (7 por fileira). Swiper só no mobile/tablet.
		const mqMobile = window.matchMedia('(max-width: 1023px)')
		let swiper = null

		const mountSwiper = () => {
			if (swiper || !mqMobile.matches) return
			swiper = new Swiper('.swiperCategoriaVotacao', {
				modules: [Navigation],
				slidesPerView: 'auto',
				spaceBetween: 12,
				grabCursor: true,
				simulateTouch: true,
				allowTouchMove: true,
				touchStartPreventDefault: false,
				threshold: 6,
				resistanceRatio: 0.75,
				preventClicks: true,
				preventClicksPropagation: true,
				navigation: {
					nextEl: '.swiper-votacao-categoria-next',
					prevEl: '.swiper-votacao-categoria-prev',
				},
			})
		}

		const destroySwiper = () => {
			if (!swiper) return
			swiper.destroy(true, true)
			swiper = null
		}

		const syncSwiper = () => {
			if (mqMobile.matches) mountSwiper()
			else destroySwiper()
		}

		syncSwiper()
		mqMobile.addEventListener('change', syncSwiper)

		const catButtons = document.querySelectorAll('[data-votacao-categoria]')
		const categoriesContent = findAll('[data-category-content]')

		const setActiveCat = (activeBtn) => {
			catButtons.forEach(btn => {
				const isActive = btn === activeBtn
				btn.classList.toggle('is-active', isActive)
				btn.setAttribute('aria-pressed', isActive ? 'true' : 'false')
			})
		}

		const filterByCategoria = (categoriaId) => {
			categoriesContent.forEach(cat => {
				const id = String(cat.dataset.categoriaId || '')
				const show = categoriaId === 'todas' || id === String(categoriaId)
				cat.classList.toggle('hidden', !show)
				cat.classList.toggle('block', show)
			})
			numbersHeader()
			numbersIndicated()
		}

		// Clique só conta se não foi arraste (botões conflitam com o drag do Swiper)
		catButtons.forEach(btn => {
			let startX = 0
			let startY = 0

			btn.addEventListener('pointerdown', (e) => {
				startX = e.clientX
				startY = e.clientY
			})

			btn.addEventListener('dragstart', (e) => e.preventDefault())

			btn.addEventListener('click', (e) => {
				const moved = Math.hypot(e.clientX - startX, e.clientY - startY) > 8
				if (moved || swiper?.animating) {
					e.preventDefault()
					e.stopPropagation()
					return
				}
				setActiveCat(btn)
				filterByCategoria(btn.dataset.votacaoCategoria)
			})
		})

		carousel.querySelectorAll('img').forEach(img => {
			img.setAttribute('draggable', 'false')
			img.addEventListener('dragstart', (e) => e.preventDefault())
		})
	}



	function numbersHeader() {
		// debugger
		// const allCategorias = findAll('[data-category-content]')
		const allCategorias = findAll('.frame.btn-top')
		const visibleCategories = allCategorias.filter(cat => cat.classList.contains('ativo'))

		const qtdCategorias = document.querySelector('[data-qtd-itens-categoria]')
		const qtdCategoriaTotal = document.querySelector('[data-total-categoria]')

		if (!qtdCategorias && !qtdCategoriaTotal) return

			const isTodasAtiva = document.getElementById('todas')?.classList.contains('ativo');
			if (isTodasAtiva) {
					// Se "todas" está ativa, mostrar o total (sem contar "todas" ela mesma)
					qtdCategorias.innerText = allCategorias.length - 1;
				} else {
					// Caso contrário, mostra apenas as que estão com "ativo"
					qtdCategorias.innerText = visibleCategories.length;
				}

		
		qtdCategoriaTotal.innerText = allCategorias.length - 1
	}

	function numbersIndicated() {
		const visibleIndicatedContainer = findAll('[data-category-content]:not(.hidden)')
		
		setTimeout(() => {
			const allIndicated = visibleIndicatedContainer.map(container =>
				container.querySelector('[name^="valor-indicado"]').value
			).filter(value => value)

			const qtdTotalIndicated = find('[data-total-indicated]')
			const qtdItensIndicated = find('[data-qtd-itens-indicated]')

			indicatedQuantity = allIndicated.length

			qtdItensIndicated.innerText = indicatedQuantity
			qtdTotalIndicated.innerText = visibleIndicatedContainer.length
		}, 100)
	}

	// Voto concluído
	function attCountdown(votingDate, element, container) {
		const now = new Date()
		const differenceTime = votingDate - now

		if (differenceTime <= 0) {
			clearInterval(votingDateInterval)
			container?.remove()

		} else {
			element.textContent = formatMilliseconds(differenceTime)
		}
	}

	function verifyVotingDate() {
		const countdownContainer = find("[data-date-released]")
		const dateValue = countdownContainer.dataset.dateReleased

		if (!dateValue || dateValue === "None") {
			countdownContainer.remove()
		} else {
			const formatedDate = formatVotingDate(dateValue)
			const countdownElement = countdownContainer.querySelector('span')

			votingDateInterval = setInterval(() => attCountdown(formatedDate, countdownElement, countdownContainer), 1000);
		}
	}


	const PERSONAL_DATA_STORAGE_KEY = 'peb_indicacao_publica_dados'
	const PERSONAL_DATA_FIELDS = ['nome', 'email', 'idade', 'genero', 'cep', 'aceita_receber_comunicacao']

	function readPersonalDataFromForm(form) {
		const data = {}

		PERSONAL_DATA_FIELDS.forEach((name) => {
			const field = form.querySelector(`[name="${name}"]`)
			if (!field) return

			if (field.type === 'checkbox') {
				data[name] = field.checked
			} else {
				data[name] = field.value || ''
			}
		})

		return data
	}

	function savePersonalDataToStorage(form) {
		try {
			const data = readPersonalDataFromForm(form)
			localStorage.setItem(PERSONAL_DATA_STORAGE_KEY, JSON.stringify(data))
		} catch (e) {
			console.warn('Não foi possível salvar dados no localStorage', e)
		}
	}

	function loadPersonalDataFromStorage() {
		try {
			const raw = localStorage.getItem(PERSONAL_DATA_STORAGE_KEY)
			if (!raw) return null
			return JSON.parse(raw)
		} catch (e) {
			console.warn('Não foi possível ler dados do localStorage', e)
			return null
		}
	}

	function restorePersonalDataToForm(form) {
		const data = loadPersonalDataFromStorage()
		if (!data) return

		PERSONAL_DATA_FIELDS.forEach((name) => {
			if (!(name in data)) return

			const field = form.querySelector(`[name="${name}"]`)
			if (!field) return

			if (field.type === 'checkbox') {
				field.checked = Boolean(data[name])
				field.value = field.checked ? '1' : '0'
			} else {
				field.value = data[name] ?? ''

				// Mantém o nice-select sincronizado com o <select> nativo
				if (field.tagName === 'SELECT' && field.instance?.update) {
					field.instance.update()
				}
			}
		})
	}

	function bindPersonalDataPersistence(form) {
		restorePersonalDataToForm(form)

		const persist = () => savePersonalDataToStorage(form)

		PERSONAL_DATA_FIELDS.forEach((name) => {
			const field = form.querySelector(`[name="${name}"]`)
			if (!field) return

			const eventName = field.type === 'checkbox' || field.tagName === 'SELECT'
				? 'change'
				: 'input'

			field.addEventListener(eventName, persist)
		})
	}

	// =================
	document.addEventListener('DOMContentLoaded', () => {
		const selectField = findAll('[js-field] select')
		const submitButton = find('[data-submit-form]')
		const niceSelectDropdown = findAll('.nice-select .nice-select-dropdown');
		const form = document.getElementById('indicacao-publica-form');
		const formSuperJuri = document.querySelector('form[name="indicacao-superjuri-form"]');

		if (Indicacao.id === 'indicacao-publica') {
			handleChangeIndicationSteps()
			updateIndicationSteps()
			handleFilterCategory()
			initCategoriaCarousel()

			findAll('[name^="valor-indicado"]')?.map(input =>
				input.addEventListener('input', numbersIndicated)
			)

			findAll('[js-select]')?.map(input =>
				input.addEventListener('change', numbersIndicated)
			)

			if (form) {
				bindPersonalDataPersistence(form)
			}

			findAll('[data-cep-mask]')?.map(input => IMask(input, {
				mask: '00000-000'
			}))
		}

		if (Indicacao.id === 'indicacao-concluida') {
			currentIndicationStep = 3
			updateIndicationSteps()
			verifyVotingDate()
		}

		niceSelectDropdown?.forEach((niceSelect) => {
			const optionOthers = niceSelect.querySelector(`.list [data-value="others"]`);
			if (!optionOthers) return;

			const fieldJogo = niceSelect.closest('[js-field]').nextElementSibling;



			const observer = new MutationObserver(function (mutations) {
				mutations.forEach(function (mutation) {
					if (mutation.target.classList.contains('selected')) {
						fieldJogo.classList.add('active');
					}
					else {
						fieldJogo.classList.remove('active');
					}
				});
			});

			observer.observe(optionOthers, { attributes: true, childList: true, characterData: true });

			//console.log(optionOthers) kd
		})

		selectField?.forEach(select => select.addEventListener('change', handleChangeSelect))
		submitButton?.addEventListener('click', (e) =>{
			e.preventDefault()
	
			verifyFieldsOnSubmit()
		})

		if (Indicacao.id === 'indicacao-publica') {
		form?.addEventListener('keydown', function (event) {
				if (event.key === 'Enter') {
					event.preventDefault(); // Impede envio via Enter
				}
			});
		}else if (Indicacao.id === 'indicacao-superjuri') {
			formSuperJuri?.addEventListener('keydown', function (event) {
				if (event.key === 'Enter') {
					event.preventDefault(); // Impede envio via Enter
				}
			});
		}
	
	})


}